// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bilanci?societaId=N',
    requestBody: null,
    response: '[{...}]'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates?societaId=N&moduloGestionale=DATI_SOCIETARI&attivo=true',
    requestBody: null,
    response: '{ success, data: [...] }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
